import { Route } from 'types/route.type';
import Palette from './components/palette-visualizer';

export const routes: Route[] = [
  {
    path: '/playground/palette',
    component: Palette,
  },
];
